import { useEffect } from 'react'

import { useExperimentsContext } from '../../../experiments/components/ExperimentsContext'
import { EXPERIMENT_NAME_PDP_AVAILABLE_RECOMMENDATION_SERVICE } from '../../../experiments/model/EXPERIMENT_NAME'
import {
  RECOMMENDATION_WIDGET_PDP_AVAILABLE,
  type RecommendationWidgetType,
} from '../../../recommendation'

export const useProductAvailableRecommendationAreaActivation = ({
  areaId,
  intersected,
}: {
  areaId: RecommendationWidgetType
  intersected: boolean
}): void => {
  const { addExperimentKeysForActivation } = useExperimentsContext()

  useEffect(() => {
    if (!intersected || areaId !== RECOMMENDATION_WIDGET_PDP_AVAILABLE) {
      return
    }

    addExperimentKeysForActivation(
      EXPERIMENT_NAME_PDP_AVAILABLE_RECOMMENDATION_SERVICE,
    )
  }, [addExperimentKeysForActivation, areaId, intersected])
}
